<template>
    <div class="app-body-container" style="padding-bottom: 30px">

        <el-row class="mg-t-10">
            <el-col :span="24">
                <el-card shadow="hover" class="mycard-a">

                    <!--监控设置-->
                    <div class="monitor-set">
                        <div class="ms-tag"><img src="@/assets/search-detail-title.png"></div>
                        <div class="ms-title">Sysale Robot会对列入监控名单的商品重点关注</div>
                        <div class="ms-btn">
                            <el-button type="primary" @click="selectGoods()">选择商品</el-button>
                        </div>
                        <div class="ms-btn2">
                            <el-button  @click="monitorSetDialogVisible=true" plain>监控设置</el-button>
                        </div>
                    </div>

                    <!--表格标题-->
                    <div class="table-title">监控名单（{{main$total}}）</div>

                    <!--表格、分页-->
                    <el-table ref="r_mainTable" :data="main$data" v-loading="main$loading" size="medium" @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55" align="center" header-align="center"></el-table-column>
                        <el-table-column prop="goodsName" label="商品" width="200" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="barcode" label="条码货号" width="200" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="skuVname" label="规格" width="140" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="unitName" label="单位" width="140" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="addTime" label="添加日期" width="180" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="errorTimes" label="异常次数" align="center" header-align="center"> </el-table-column>
                    </el-table>
                    <div style="margin: 14px">
                        <el-checkbox label="全选" name="type" @change="selectAll"></el-checkbox>
                        <el-button style="margin-left: 15px;" @click="removeMonitorList" plain>移除</el-button>
                        <el-pagination style="float: right"
                                       background
                                       layout="total, sizes, prev, pager, next"
                                       :page-size="main$page_size"
                                       :current-page="main$curr_page"
                                       :total="main$total"
                                        @current-change="handlePageChange"></el-pagination>
                    </div>

                </el-card>
            </el-col>
        </el-row>

        <!--选择商品对话框-->
        <el-dialog title="选择商品"
                   :visible.sync="selGoodsDialogVisible"
                   class="mydialog" width="800px"
                   :append-to-body="true">
            <div style="margin-bottom: -15px">
                <!--查询条件-->
                <el-form :inline="true" class="myform">
                    <el-form-item label="关键字">
                        <el-input placeholder="商品名称/条码" v-model="selGoods$query_condition"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="fetchData_goods">搜索</el-button>
                    </el-form-item>
                </el-form>
                <!--table-->
                <el-table :data="selGoods$data" v-loading="selGoods$loading" size="medium"
                          style="min-height: 270px;margin: 10px 0px"
                          @selection-change="handleSelectionChange_goods">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column prop="goodsName" label="商品" width="220" align="center" header-align="center"> </el-table-column>
                    <el-table-column prop="barcode" label="条码货号" width="180" align="center" header-align="center"> </el-table-column>
                    <el-table-column prop="skuVname" label="规格" align="center" header-align="center"> </el-table-column>
                </el-table>
                <div style="clear: both"></div>
            </div>
            <div style="padding: 28px 0 14px 0">
                <el-pagination style="float: right"
                               background
                               layout="total, sizes, prev, pager, next"
                               :page-size="main$page_sizes"
                               :current-page="main$curr_pages"
                               :total="main$totals"
                               @current-change="handlePageChanges"></el-pagination>
            </div>
            <div slot="footer">
                <el-button class="mybtn-blue2" @click="addMonitorList">加入监控名单</el-button>
            </div>
        </el-dialog>

        <!--监控设置对话框-->
        <el-dialog title="监控设置" :visible.sync="monitorSetDialogVisible" class="mydialog" :append-to-body="true">
            <el-form :label-position="'left'" label-width="105px" class="myform">
                <el-form-item label="自动汇报频率">
                    <el-select placeholder="请选择" style="width: 165px" v-model="input_rate">
                        <el-option v-for="(rate,rate_idx) in data_rate" :key="rate_idx"
                                   :label="rate.value" :value="rate.code"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-form :label-position="'top'" class="myform">
                <el-form-item label="汇报内容" class="checkbox-huibao">
                    <el-checkbox-group v-model="input_content">
                        <!--非固定选项-->
                        <el-checkbox v-for="(item,item_idx) in data_content"
                                     :key="item_idx"
                                     v-if="item.value2 ==='0'"
                                     :label="item.code">{{item.value}}</el-checkbox>
                        <!--固定选项-->
                        <br/>
                        <el-checkbox v-for="(item,item_idx) in data_content"
                                     :key="item_idx"
                                     v-if="item.value2 ==='1'"
                                     :label="item.code" disabled>{{item.value}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button class="mybtn-blue2" style="width: 170px" @click="saveMonitor">保存</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
export default {
    data: function () {
        return {
            // 表格数据
            main$page_size: 10,
            main$curr_page: 1,
            main$loading: false,
            main$total: 0,
            main$data: [],
            main$selection: [],
            // 选择商品
            selGoodsDialogVisible: false,
            selGoods$query_condition: '',
            selGoods$loading: false,
            selGoods$data: [],
            selGoods$selection: [],
            // 监控设置
            monitorSetDialogVisible: false,
            data_rate: [],       // 监控频率
            data_content: [],    // 监控内容,
            input_rate: null,    // 当前选中监控频率
            input_content: [],   // 当前选中监控内容

            main$page_sizes: 10,
            main$curr_pages: 1,
            main$totals: 0,
        }
    },
    methods: {
        fetchData: function () {
            let self = this;

            self.main$loading = true

            self.xFetch.post(self.xApi('/robot/monitor/getMonitorList'), {
                page: self.main$curr_page,
                rows: self.main$page_size
            },{xPostType:'form'}).then(function (res) {
                self.main$loading = false

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    self.main$total = 0;
                    self.main$data = [];
                }
                else {
                    self.main$total = res.data.total;
                    self.main$data = res.data.rows;
                }
            });
        },
        handlePageChange: function (val) {
            this.main$curr_page = val;
            this.fetchData();
        },
        handlePageChanges: function (val) {
            this.main$curr_pages = val;
            this.fetchData_goods();
        },
        selectAll: function (bol) {
            let self = this
            self.main$data.forEach(function (row) {
                self.$refs.r_mainTable.toggleRowSelection(row, bol);
            })
        },
        handleSelectionChange: function (val) {
            this.main$selection = val
        },
        // 选择商品
        selectGoods: function(){
            this.selGoodsDialogVisible = true;
            this.fetchData_goods();
        },
        fetchData_goods: function(){
            let self = this;

            self.selGoods$loading = true

            self.xFetch.post(self.xApi('/robot/monitor/getGoodsList'), {
                condition: self.selGoods$query_condition,
                page: self.main$curr_pages,
                rows: self.main$page_sizes
            },{xPostType:'form'}).then(function (res) {
                self.selGoods$loading = false

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    self.main$totals = 0;
                    self.selGoods$data = [];
                }
                else {
                    self.main$totals = res.data.total;
                    self.selGoods$data = res.data.rows;
                }
            });
        },
        handleSelectionChange_goods: function (val) {
            this.selGoods$selection = val
        },
        // 添加到监控列表
        addMonitorList: function () {
            let self = this

            if(!this.selGoods$selection.length){
                this.xEui.msg_error('请至少选中一个商品')
                return;
            }

            // 选中的商品id
            let ids = [];
            this.selGoods$selection.forEach(function(item){
                ids.push(item.id)
            });

            // save
            self.xEui.myloading('操作中...');

            self.xFetch.post(self.xApi('/robot/monitor/addMonitorList'), {
                'ids[]': ids.join(',')
            },{xPostType:'form'}).then(function (res) {
                self.xEui.loading_close();

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                }
                else {
                    self.xEui.msg_success('添加成功')
                    self.selGoodsDialogVisible = false
                    self.fetchData();
                }
            });
        },
        // 从监控列表移除
        removeMonitorList: function () {
            let self = this

            // check
            if (!self.main$selection.length) {
                self.xEui.msg_error('请选择一行进行操作');
                return
            }

            // ids
            let ids = []
            self.main$selection.forEach(function (item) {
                ids.push(item.id)
            });

            // save
            self.xEui.myloading('操作中...');

            self.xFetch.post(self.xApi('/robot/monitor/removeMonitorList'), {
                'ids[]': ids.join(',')
            },{xPostType:'form'}).then(function (res) {
                self.xEui.loading_close()

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                }
                else {
                    self.xEui.msg_success('移除成功')
                    self.fetchData();
                }
            });
        },
        // 保存监控设置
        saveMonitor: function () {
            let self = this

            // check
            if (!self.input_rate) {
                self.xEui.msg_error('请选择监控频率');
                return
            }

            // save
            self.xEui.myloading('操作中...');

            self.xFetch.post(self.xApi('/robot/monitor/saveMonitor'), {
                rate: self.input_rate,
                content: self.input_content.join(',')
            },{xPostType:'form'}).then(function (res) {
                self.xEui.loading_close();

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                }
                else {
                    self.xEui.msg_success('保存成功')
                    self.monitorSetDialogVisible = false
                }
            });
        }
    },
    created: function () {
        let self = this

        // 加载表格数据
        self.fetchData();

        // 载入监控设置
        self.xFetch.post(self.xApi('/robot/monitor/getRate'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.data_rate = res.data.data;

            self.xFetch.post(self.xApi('/robot/monitor/getMonitor'), {}).then(function (res) {
                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    return
                }
                self.data_content = res.data.data.contentList;

                // 当前监控率
                self.input_rate = (res.data.data.rate || '') + ''

                // 当前监控项
                let content = [];

                if (res.data.data.content) {
                    content = res.data.data.content.split(',')
                }

                self.data_content.forEach(function(item){
                    if(item.value2 == '1'){
                        content.push(item.code)
                    }
                });

                self.input_content = Array.from(new Set(content))
            });
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /*monitor-set*/
    .monitor-set{
        width: 586px;
        margin: 15px auto 80px auto;
        border: 1px solid #2377E4;
        text-align: center;
        position: relative
    }
    .monitor-set .ms-tag{ position: absolute;left: 30px;top: 0px }
    .monitor-set .ms-tag img{ height: 50px }
    .monitor-set .ms-title{ font-size: 20px;color: #0061ee;padding-top: 70px;padding-bottom: 35px }
    .monitor-set .ms-btn{ padding-bottom: 20px }
    .monitor-set .ms-btn .el-button{ width: 280px;background: #0061EE;border-color: #0061EE; }
    .monitor-set .ms-btn2{ padding-bottom: 25px }
    .monitor-set .ms-btn2 .el-button{ width: 130px; }
    /*table-title*/
    .table-title{ color: #2377E4;font-size: 15px;font-weight: 700;padding-bottom: 10px }
</style>
<style>
    /*选择商品*/
    .sel-goods-list .el-checkbox{ margin-left: 0;margin-right: 30px }
    /*监控设置对话框*/
    .checkbox-huibao .el-checkbox{ margin-left: 0;min-width: 155px }
</style>



// WEBPACK FOOTER //
// src/views/inventory/monitor-list.vue